<div class="mini-layout g-mini-layout-background">
  @if (showLanguages) {
    <div class="actions language">
      <app-flyout [settings]="languageFlyout" (onSelect)="changeLanguage($event)">
      </app-flyout>
    </div>
  }
  <div class="actions right">
    @if (showLogout) {
      <app-ui-button [variant]="'secondary'" [size]="'small'" [label]="logoutText" (clicked)="rightActionsClick()"></app-ui-button>
    }
  </div>
  <div class="actions left">
    <app-em-breadcrumbs></app-em-breadcrumbs>
  </div>
  <!-- MAIN CONTENT  -->
  <div class="top">
    <div class="logo-wrapper" [ngClass]="logoPosition === 'left' ? 'left' : ''">
      <div class="logo"></div>
      <app-icp-em-tag size="large"></app-icp-em-tag>
    </div>
    <!-- TITLE -->
    <ng-content select=".mini-layout__title"></ng-content>
    <!-- Main Text -->
    <ng-content select=".mini-layout__text"></ng-content>
    <!-- Action Button -->
    <ng-content select=".mini-layout__btn"></ng-content>
    <ng-content></ng-content>
  </div>
  <!-- FOOTER -->
  <div class="credit">
    <app-copyright></app-copyright>
  </div>
</div>
